
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import filters from './filter'
import store from './store'
import axios from 'axios'
import Vuelidate from 'vuelidate'
import {i18n} from './i18n'
import eventBus from './event-bus'
import realTimeClient from '@/real-time-client'
import VueBreadcrumbs from 'vue-2-breadcrumbs';
import VueQuillEditor from 'vue-quill-editor'


Vue.use(preview)

// 引入element插件，用于使用elementui
import './plugins/element.js'
//  方法
import './utils/utils.js'

import './style/index.scss'

import '../public/static/themes/hadmin/css/bootstrap.min.css'
import '../public/static/themes/hadmin/css/font-awesome.min.css?v=4.4.0'
import '../public/static/themes/hadmin/css/animate.css'
import '../public/static/themes/hadmin/css/style.css'

import '../public/static/themes/hadmin/js/bootstrap.min.js'
import '../public/static/themes/hadmin/js/plugins/metisMenu/jquery.metisMenu.js'
import '../public/static/themes/hadmin/js/plugins/slimscroll/jquery.slimscroll.js'
// import '../public/static/themes/hadmin/js/plugins/layer/layer.min.js'
// import '../public/static/themes/hadmin/js/plugins/layer/skin/layer.css'

import '../public/static/themes/hadmin/js/hplus.js?v=4.1.0'
import '../public/static/themes/hadmin/js/contabs.js'

import '../public/static/themes/hadmin/js/plugins/pace/pace.min.js'



for (let key in filters) {
    Vue.filter(key, filters[key]);
}

// Bootstrap axios
//axios.defaults.baseURL = '/api'
//axios.defaults.headers.common.Accept = 'application/json'



axios.interceptors.request.use(
    config => {
        config.baseURL = '/api/'
        // config.baseURL = '/'
        //config.withCredentials = false // 允许携带token ,这个是解决跨域产生的相关问题
        config.timeout = 6000
        config.headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
            //config

        // if (config.url === 'refresh') {
//    config.headers = {
//     'refresh-token': sessionStorage.getItem('refresh_token'),
//     'Content-Type': 'application/x-www-form-urlencoded'
//    }
//   }
        return config
    },
    error => {
        return Promise.rbaseURLeject(error)
    }
)

axios.interceptors.response.use(
    response => response,
    (error) => {
        return Promise.reject(error)
    }
)

// Enable Vuelidate
Vue.use(Vuelidate)

Vue.config.productionTip = true

Vue.prototype.$bus = eventBus
Vue.prototype.$rt = realTimeClient


Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.use(VueBreadcrumbs);

// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)

new Vue({
    router,
    store,
    i18n,
    //layer,
    render: h => h(App)
}).$mount('#app')
